<nav class="navbar navbar-dark bg-black w-100 py-3 position-fixed top-0 start-0 landing-navbar">
  <div class="container-fluid px-3 px-md-4 px-lg-5 d-flex align-items-center justify-content-between">

    <router-link to="/" class="navbar-brand brand-logo m-0" aria-label="BCX Home"></router-link>

    <router-link
      :to="{ name: 'login' }"
      class="btn btn-primary rounded-pill fw-semibold text-xs text-decoration-none landing-login-link"
    >
      Login
    </router-link>

  </div>
</nav>
